import { ContentItem } from '@kentico/kontent-delivery';
import { get } from 'lodash';
import { ICheckboxProps } from '../components/form/components/checkbox/checkbox';
import { IGroupedCheckboxesProps } from '../components/form/components/groupedCheckboxes/groupedCheckboxes';
import { CheckboxModel } from './checkbox-model';

export class CheckboxesGroupModel extends ContentItem {
  get type(): string {
    return get(this._config, 'system.type', '');
  }

  get checkboxes(): ICheckboxProps[] {
    const getCheckbox = get(this._config, 'elements.checkboxes.value', null);

    const transformCheckbox = getCheckbox
      ? getCheckbox.map((checkbox: ICheckbox) => CheckboxModel.create(checkbox))
      : null;

    return transformCheckbox;
  }

  get errorMessage(): string {
    return get(this._config, 'elements.error_message.value', '');
  }

  get groupName(): string {
    return get(this._config, 'elements.group_name.value', '');
  }

  get multipleChoiceCheckboxes(): boolean {
    return (
      get(
        this._config,
        'elements.multiple_choice_checkboxes.value[0].name',
        ''
      ) === 'true'
    );
  }

  get required(): boolean {
    return get(this._config, 'elements.required.value[0].name', '') === 'true';
  }

  get subtitle(): string {
    return get(this._config, 'elements.subtitle.value', '');
  }

  get title(): string {
    return get(this._config, 'elements.title.value', '');
  }

  public static create(data: IGroupedCheckboxes): IGroupedCheckboxesProps {
    const {
      type,
      title,
      subtitle,
      checkboxes,
      required,
      multipleChoiceCheckboxes,
      groupName,
      errorMessage
    } = new CheckboxesGroupModel(data);
    return {
      type,
      title,
      subtitle,
      checkboxes,
      required,
      multipleChoiceCheckboxes,
      groupName,
      errorMessage
    };
  }
}
